export default [
  {
    workplace: 'ASCAP',
    description: [
      'Led development to modernize codebase and migrate front end from backbone.js to Vue.js through building a component library and a style system',
    ],
    link: 'https://ascap.com',
  },
  {
    workplace: 'Thingiverse',
    description: [
      'Full Stack development on a site with millions of users on a custom framework using PHP and JavaScript',
    ],
    link: 'https://thingiverse.com',
  },
  {
    workplace: 'Pink Art Machine',
    description: [
      'Designed and built a fully responsive custom portfolio site using Vue.js using AWS (Amazon Web Services) such as S3 to reduce costs for client',
    ],
    link: 'http://pinkartmachine.com/#/',
  },
  {
    workplace: 'TJMaxx',
    description: [
      'Built a site for TJMaxx to promote their Maxx You Project, dedicated to supporting women',
    ],
    link: 'https://maxxyouproject.com/',
  },
];